module.exports = __webpack_public_path__ + "static/media/card25.26621171.png";